module.exports = __webpack_public_path__ + "img/filtros-foto.a2d3e547.svg";